import { useSyncExternalStore } from 'react'
import { onlineManager } from '@tanstack/react-query'

// App-wide connectivity signal. onlineManager tracks the browser's
// online/offline events; everything (offline banner, login page, controls
// disabled while offline) reads from here so they stay consistent.
export function useOnline(): boolean {
  return useSyncExternalStore(
    (onChange) => onlineManager.subscribe(onChange),
    () => onlineManager.isOnline(),
  )
}
